module.exports = __webpack_public_path__ + "img/gz3.12e31510.jpg";